import { autoMount } from '../../../utils/autoMount';
import { Preference } from '../../../components/organisms/preference';

autoMount({ Preference });
